const DataTitle = ({ title }: any) => (
  <div className="blocks_sort">
    <div className="blocks_sort_heading">{title}</div>
  </div>
);

export default DataTitle;
